export class FalconSetting {
  id?: number;
  name?: string;
  scope?: string;
  value?: string;
  description?: string;
  language?: string;
  version?: number;

  constructor(id : number, name : string, scope : string, value : string, description : string, language : string, version : number) {
    this.id = id;
    this.name = name;
    this.scope = scope;
    this.value = value;
    this.description = description;
    this.language = language;
    this.version = version;
  }
}
